// extracted by mini-css-extract-plugin
export default {"note":"styles_note__qFcLk","question":"styles_question__okwD9","label":"styles_label__6H9Oz","content":"styles_content__CaR1s","rot":"styles_rot__oQlrU"};